var defaults = require('superagent-defaults');

var superagent = defaults();

function getToken() {
   return document.querySelector("meta[name='csrf-token']").getAttribute("content")
}

superagent
  .set("X-CSRF-Token", getToken())


export { superagent }



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/shared/superagent/superagent.js